import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { Region } from './region.interface';
import { RegionService } from './region.service';
const service = new RegionService();

export interface RegionState {
   regions: Array<Region>;
}

const RegionStore: Module<RegionState, StoreState> = {
   namespaced: true,
   state: {
      regions: [],
   },
   getters: {
      regions: (state) => state.regions,
   },
   mutations: {
      setRegions(state, regions: Array<Region>) {
         state.regions = regions;
      },
   },
   actions: {
      async getRegions(context) {
         return await service.getRegions().then((regions) => {
            context.commit('setRegions', regions);
            return regions;
         });
      },
      async getRegion(context, regionId: number) {
         return await service.getRegionsById(regionId);
      },
   },
};

export default RegionStore;
